import {apsCommon} from "../shared/dto/aps.common";
import {apsViewModels} from "../shared/dto/APS.ViewModels";
import * as angular from "angular";
import * as _ from "lodash";
import AuthDataServiceName, {AuthDataService} from "../services/auth/authData.service";
import {NotificationHub} from "../services/notifications/notification.hub";

export interface Plant extends apsViewModels.PlantNavigation {
  shops: apsViewModels.ShopNavigation[];
}

export interface NavigationModel {
  plants(): Plant[];
  shops(): apsViewModels.ShopNavigation[];
  allShops(): apsViewModels.ShopNavigation[];
  selectedPlant: Plant;
  selectedShop: apsViewModels.ShopNavigation;
  plantChanged(): void;
  roleChanged(): void;
  selectPlant(plant: Plant): boolean;
  selectPlantShop(plant: Plant, shop: apsViewModels.ShopNavigation): boolean;
  initialize(notificationHub: NotificationHub, userData: apsViewModels.UserData): void;
  uninitialize(): void;
}

export interface NavigationCtor {
  new (data: apsViewModels.PlantNavigation[],
       getCurrentRole: () => apsCommon.UserRolePlants): NavigationModel;
}

class NavigationImpl implements NavigationModel {
  static authDataService: AuthDataService;

  private notificationHub: NotificationHub;
  selectedPlant: Plant;
  selectedShop: apsViewModels.ShopNavigation;
  private allPlants: Plant[];
  private getCurrentRole: () => apsCommon.UserRolePlants;
  private userData: apsViewModels.UserData;

  constructor(data: apsViewModels.PlantNavigation[],
              getCurrentRole: () => apsCommon.UserRolePlants) {
    this.allPlants = _.map(data, p => {
      var plant = <Plant>_.assign({}, p);
      plant.shops = _.flatten<apsViewModels.ShopNavigation>(_.map(p.tanks, 'shops'));
      return plant;
    });
    this.getCurrentRole = getCurrentRole;

    this.roleChanged();
  }

  initialize(notificationHub: NotificationHub, userData: apsViewModels.UserData) {
    this.notificationHub = notificationHub;
    this.userData = userData;
  }

  uninitialize() {
    if (this.notificationHub) {
      this.notificationHub.uninitialize();
      this.notificationHub.disconnect();
    }
  }

  plants(): Plant[] {
    var role = this.getCurrentRole();
    if (!role) {
      return undefined;
    }

    return this.allPlants.concat([]);
  }

  shops(): apsViewModels.ShopNavigation[] {
    if (this.selectedPlant) {
      return this.selectedPlant.shops.concat([]);
    }
    return undefined;
  }

  allShops(): apsViewModels.ShopNavigation[] {
    var shops = [];
    _.forEach(this.allPlants, (plant) => {
      shops = shops.concat(plant.shops);
    });
    return shops;
  }

  plantChanged(): void {
    var oldShop = this.selectedShop;

    this.selectedShop = undefined;
    var role = this.getCurrentRole();
    if (oldShop) {
      this.selectedShop = _.find(this.shops(), {id: oldShop.id});
    }
    if (!this.selectedShop && role && role.lastShopId) {
      this.selectedShop = _.find(this.shops(), {id: role.lastShopId});
    }
    if (!this.selectedShop) {
      this.selectedShop = _.first(this.shops());
    }
  }

  roleChanged(): void {
    var oldPlant = this.selectedPlant;

    this.selectedPlant = undefined;
    var role = this.getCurrentRole();
    if (oldPlant) {
      this.selectedPlant = _.find(this.plants(), {id: oldPlant.id});
    }
    if (!this.selectedPlant && role && role.roleRequiresPlants && role.lastPlantId) {
      this.selectedPlant = _.find(this.plants(), {id: role.lastPlantId});
    }
    if (!this.selectedPlant) {
      this.selectedPlant = _.first(this.plants());
    }
    this.plantChanged();
  }

  selectPlant(plant: Plant): boolean {
    if (!plant) {
      return false;
    }

    return this.selectPlantShop(plant, _.first(plant.shops));
  }

  selectPlantShop(plant: Plant, shop: apsViewModels.ShopNavigation): boolean {
    if (!shop || this.selectedShop === shop) {
      return false;
    }

    var plantChanged = (this.selectedPlant !== plant);
    if (plantChanged) {
      this.selectedPlant = plant;
    }
    this.selectedShop = shop;

    var role = this.getCurrentRole();
    NavigationImpl.authDataService.setSelectedRoleLocation(role,
      this.selectedPlant, this.selectedShop);
    return true;
  }
}

export default angular.module('navigation', [AuthDataServiceName])
  .factory('Navigation', function (authDataService: AuthDataService) {
    NavigationImpl.authDataService = authDataService;
    return NavigationImpl;
  }).name;


// WEBPACK FOOTER //
// ./src/app/models/navigation.ts